import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Oidc, { UserManager } from 'oidc-client/lib/oidc-client';
import jwtDecode from 'jwt-decode';
import Events from './events';
import random from './random';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
var ERROR_MESSAGES_TO_IGNORE = ['End-User authentication is required'];
export default function Auth(options) {
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;
  var basePathname = options.basePathname || '';
  var isLocalhost = location.origin.indexOf('://localhost') >= 0;
  var events = {
    signInNeeded: new Events(),
    signIn: new Events(),
    signOut: new Events(),
    stateChange: new Events(),
    setLocation: new Events(),
    signInError: new Events(),
    signOutError: new Events(),
    sessionExpired: new Events()
  };
  options = _objectSpread({
    basePathname: basePathname,
    clientId: "".concat(location.origin).concat(basePathname),
    redirectUri: "".concat(location.origin).concat(basePathname, "/oidc_signin"),
    postLogoutRedirectUri: "".concat(location.origin).concat(basePathname, "/oidc_signout"),
    silentRedirectUri: "".concat(location.origin).concat(basePathname, "/oidc_renew"),
    popup: false,
    popupRedirectUri: "".concat(location.origin).concat(basePathname, "/oidc_signin"),
    popupWindowFeatures: 'location=no,toolbar=no,width=500,height=800,left=100,top=100',
    popupWindowTarget: '_blank',
    responseType: 'code',
    responseMode: 'query',
    scope: "openid profile company permissions email recovery address phone".concat(options.offlineAccess ? ' offline_access' : ''),
    filterProtocolClaims: true,
    automaticSilentRenew: false,
    // handle this with an event
    revokeAccessTokenOnSignOut: true,
    loadUserInfo: true,
    clockSkew: 600,
    monitorAccessTokenExpiration: true,
    checkRecoveryMethods: true
  }, options || {}); // create a storate key to track where to return

  var returnToKey = "bridge.returnTo.".concat(options.clientId); // create a storate key to track where to return
  //const idTokenKey = `bridge.idToken.${ options.clientId }`;

  var referrer = document ? document.referrer : null;

  if (referrer) {
    options.extraQueryParams = _objectSpread(_objectSpread({}, options.extraQueryParams || {}), {}, {
      referrer: referrer.split('?')[0]
    });
  } // check to see if a sso_token was passed along


  var ssoToken = getSSOToken();

  if (ssoToken) {
    options.extraQueryParams = _objectSpread(_objectSpread({}, options.extraQueryParams || {}), {}, {
      ssoToken: ssoToken
    });
  } // legacy support for company-setup


  if (options.clientId === 'admin') {
    options.clientId = "admin:".concat(location.origin).concat(basePathname);
  } // make trace functions


  function getTraceLocation() {
    if (options.debugLocation) {
      return " location: ".concat(window.location.href);
    }

    return '';
  }

  function getTraceIdToken() {
    /*
    if ( options.debugIdToken ) {
        let idToken = '';
        if ( localStorage && localStorage.getItem ) {
            idToken = localStorage.getItem( idTokenKey );
        }
        return ` id_token: ${ !!idToken }`;
    }
    */
    return '';
  }

  function traceStart(name) {
    if (options.debug === true || options.debug === undefined && isLocalhost) {
      console.group();
      console.debug("".concat(name).concat(getTraceLocation()).concat(getTraceIdToken(), " entered"));
      return {
        end: function end(value) {
          console.debug("".concat(name).concat(getTraceLocation()).concat(getTraceIdToken(), " exited"));
          console.groupEnd();
          return value;
        }
      };
    } // return an end function that does nothing


    return {
      end: function end(value) {
        return value;
      }
    };
  } // have oidc library log to the console.


  if (options.debug === true || options.debug === undefined && isLocalhost) {
    if (options.debugClient !== false) {
      Oidc.Log.logger = console;
      Oidc.Log.level = Oidc.Log.DEBUG;
    }
  } // make sure uris are in lower case


  options.redirectUri = options.redirectUri.toLowerCase();
  options.postLogoutRedirectUri = options.postLogoutRedirectUri.toLowerCase();
  options.silentRedirectUri = options.silentRedirectUri.toLowerCase();

  var getRootUri = function getRootUri(includeQuery) {
    var trace = traceStart('getRootUri');

    if (includeQuery) {
      return trace.end("".concat("".concat(location.origin).concat(options.basePathname).toLowerCase()).concat(location.search));
    } else {
      return trace.end("".concat(location.origin).concat(options.basePathname).toLowerCase());
    }
  };

  var getCurrentUri = function getCurrentUri(includeQuery) {
    var trace = traceStart('getCurrentUri');

    if (includeQuery) {
      return trace.end("".concat("".concat(location.origin).concat(location.pathname).toLowerCase()).concat(location.search));
    } else {
      return trace.end("".concat(location.origin).concat(location.pathname).toLowerCase());
    }
  };

  var isAuthUri = function isAuthUri(uri) {
    var trace = traceStart('isAuthUri');

    if (!uri) {
      uri = getCurrentUri();
    }

    return trace.end(uri === options.redirectUri || uri === options.postLogoutRedirectUri || uri === options.silentRedirectUri);
  }; // if we are in an auth url; don't run the session check


  if (isAuthUri(getCurrentUri())) {
    options.monitorSession = false;
  } // create the user manager


  var userManager = new UserManager(getUserManagerConfig(options)); // remove stale state

  userManager.clearStaleState();
  var state = {};
  var cache = {};

  var getUser = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var trace, user;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              trace = traceStart('getUser');
              _context.next = 3;
              return userManager.getUser();

            case 3:
              user = _context.sent;
              refreshState(user);
              return _context.abrupt("return", trace.end(user));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getUser() {
      return _ref.apply(this, arguments);
    };
  }();

  var removeUser = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var trace;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              trace = traceStart('removeUser');
              _context2.next = 3;
              return userManager.removeUser();

            case 3:
              _context2.next = 5;
              return userManager.clearStaleState();

            case 5:
              refreshState(null);
              return _context2.abrupt("return", trace.end());

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function removeUser() {
      return _ref2.apply(this, arguments);
    };
  }();

  var refreshState = function refreshState(user, delegateUser) {
    var trace = traceStart('refreshState');
    var original = {
      access_token: user ? user.access_token : null,
      access_token_expires_at: user && user.expires_at ? new Date(user.expires_at * 1000) : null,
      refresh_token: user ? user.refresh_token : null,
      subject: user ? user.profile.sub : null,
      claims: {
        company_id: user ? user.profile.company_id : null,
        person_id: user ? user.profile.person_id : null,
        username: user ? user.profile.preferred_username : null,
        name: user ? user.profile.name : null,
        family_name: user ? user.profile.family_name : null,
        given_name: user ? user.profile.given_name : null,
        locale: user ? user.profile.locale : null,
        country: user ? user.profile.country : null,
        email: user ? user.profile.email : null,
        emails: user ? user.profile.emails : null,
        phone_number: user ? user.profile.phone_number : null,
        phone_numbers: user ? user.profile.phone_numbers : null,
        address: user ? user.profile.address : null,
        addresses: user ? user.profile.addresses : null,
        picture: user ? user.profile.picture : null,
        permissions: user ? user.profile.permissions : null,
        permittedCompanyIds: user ? user.profile.permitted_company_ids : null,
        attributes: user ? user.profile.attributes || {} : null
      }
    };
    var delegate = {
      access_token: delegateUser ? delegateUser.access_token : null,
      subject: delegateUser ? delegateUser.subject : null,
      claims: {
        company_id: delegateUser ? delegateUser.company_id : null,
        person_id: delegateUser ? delegateUser.person_id : null,
        username: delegateUser && user ? user.profile.preferred_username : null,
        name: delegateUser && user ? user.profile.name : null,
        family_name: delegateUser && user ? user.profile.family_name : null,
        given_name: delegateUser && user ? user.profile.given_name : null,
        locale: delegateUser && user ? user.profile.locale : null,
        country: delegateUser && user ? user.profile.country : null,
        email: delegateUser && user ? user.profile.email : null,
        emails: delegateUser && user ? user.profile.user : null,
        phone_number: delegateUser && user ? user.profile.phone_number : null,
        phone_numbers: delegateUser && user ? user.profile.phone_numbers : null,
        address: delegateUser && user ? user.profile.address : null,
        addresses: delegateUser && user ? user.profile.addresses : null,
        picture: delegateUser && user ? user.profile.picture : null,
        permissions: delegateUser ? delegateUser.permissions : null,
        permittedCompanyIds: delegateUser && user ? user.profile.permitted_company_ids : null,
        attributes: delegateUser ? {} : null
      }
    };
    var newState = {
      client_id: options.clientId,
      id_token: user ? user.id_token : null,
      session_id: user ? user.profile.sid : null,
      access_token: delegateUser ? delegate.access_token : original.access_token,
      access_token_expires_at: original.access_token_expires_at,
      refresh_token: original.refresh_token,
      subject: delegateUser ? delegate.subject : original.subject,
      claims: _objectSpread({}, delegateUser ? delegate.claims : original.claims),
      original: original,
      delegate: delegate,
      actor: delegateUser ? delegateUser.act : user ? user.profile.act : null
    };
    var didStateChange = JSON.stringify(state || {}) !== JSON.stringify(newState);

    if (didStateChange) {
      state = newState;
      events.stateChange.fire(state);
    }

    return trace.end();
  };

  var resume = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(session, signInOnResumeError) {
      var trace, result;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              trace = traceStart('resume');
              _context3.next = 3;
              return signInOrResume(true, session, signInOnResumeError);

            case 3:
              result = _context3.sent;
              return _context3.abrupt("return", trace.end(result));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function resume(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var signIn = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var trace, result;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              trace = traceStart('signIn');
              _context4.next = 3;
              return signInOrResume(false);

            case 3:
              result = _context4.sent;
              return _context4.abrupt("return", trace.end(result));

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function signIn() {
      return _ref4.apply(this, arguments);
    };
  }();

  var signInOrResume = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(isResuming, session, signInOnResumeError) {
      var trace, p, result, _p, _result, errorMessage, cancelRetry, _result2;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              trace = traceStart('signInOrResume'); // make sure sign in is only called once at a time
              // the auth process keeps some state and this can get mismatched if called multiple times

              if (!cache.signInOrResumePromise) {
                _context5.next = 7;
                break;
              }

              p = cache.signInOrResumePromise;
              _context5.next = 5;
              return Promise.resolve(p);

            case 5:
              result = _context5.sent;
              return _context5.abrupt("return", trace.end(result));

            case 7:
              _context5.prev = 7;
              _p = signInOrResumeHelper(isResuming, session, signInOnResumeError);
              cache.signInOrResumePromise = _p;
              _context5.next = 12;
              return Promise.resolve(_p);

            case 12:
              _result = _context5.sent;
              return _context5.abrupt("return", trace.end(_result));

            case 16:
              _context5.prev = 16;
              _context5.t0 = _context5["catch"](7);
              // error messages from OpenId Connect are error_description, JS errors are message
              errorMessage = _context5.t0 ? _context5.t0.error_description || _context5.t0.message : '';

              if (!(isResuming && signInOnResumeError)) {
                _context5.next = 35;
                break;
              }

              console.error(_context5.t0);
              cancelRetry = false;
              events.signInError.fire({
                error: _context5.t0,
                preventDefault: function preventDefault() {
                  return cancelRetry = true;
                }
              });

              if (!cancelRetry) {
                _context5.next = 25;
                break;
              }

              return _context5.abrupt("return", trace.end());

            case 25:
              _context5.next = 27;
              return userManager.removeUser();

            case 27:
              _context5.next = 29;
              return userManager.clearStaleState();

            case 29:
              _context5.next = 31;
              return signInOrResume(false);

            case 31:
              _result2 = _context5.sent;
              return _context5.abrupt("return", trace.end(_result2));

            case 35:
              if (!ERROR_MESSAGES_TO_IGNORE.includes(errorMessage)) {
                _context5.next = 37;
                break;
              }

              return _context5.abrupt("return", trace.end());

            case 37:
              console.error(_context5.t0);
              events.signInError.fire({
                error: _context5.t0,
                preventDefault: function preventDefault() {
                  return false;
                }
              });

            case 39:
              _context5.prev = 39;
              cache.signInOrResumePromise = undefined;
              return _context5.finish(39);

            case 42:
              return _context5.abrupt("return", trace.end());

            case 43:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[7, 16, 39, 42]]);
    }));

    return function signInOrResume(_x3, _x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();

  var signInOrResumeHelper = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(isResuming, session, signInOnResumeError) {
      var trace, user, uri, returnToUri, returnToType, source, cancelSignIn;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              trace = traceStart('signInOrResumeHelper');
              user = null;
              uri = getCurrentUri();
              returnToUri = getCurrentUri(true);
              _context6.t0 = uri;
              _context6.next = _context6.t0 === options.redirectUri ? 7 : _context6.t0 === options.popupRedirectUri ? 7 : _context6.t0 === options.silentRedirectUri ? 22 : _context6.t0 === options.postLogoutRedirectUri ? 28 : 43;
              break;

            case 7:
              if (!options.popup) {
                _context6.next = 12;
                break;
              }

              _context6.next = 10;
              return userManager.signinPopupCallback();

            case 10:
              _context6.next = 14;
              break;

            case 12:
              _context6.next = 14;
              return userManager.signinRedirectCallback();

            case 14:
              // restore the location
              if (localStorage && localStorage.getItem) {
                returnToUri = localStorage.getItem(returnToKey); // if nothing was stored return to the current uri

                if (!returnToUri) {
                  returnToUri = getRootUri(true);
                }
              } // get the user


              _context6.next = 17;
              return getUser();

            case 17:
              user = _context6.sent;
              // store id_token in storage

              /*
              if ( user ) {
                  if ( localStorage && localStorage.setItem ) {
                      localStorage.setItem( idTokenKey, user.id_token );
                  }
              }
              */
              // check to see if recovery methods are needed.
              returnToType = LocationType.SIGN_IN;

              if (user && user.profile) {
                if (options.checkRecoveryMethods && user.profile.recovery_methods_set === false) {
                  if (user.profile.recovery_methods_url) {
                    returnToType = LocationType.RECOVERY_METHODS;
                    source = encodeURIComponent(returnToUri);

                    if (source === 'undefined') {
                      source = encodeURIComponent(getRootUri(true));
                    }

                    returnToUri = "".concat(user.profile.recovery_methods_url, "?source=").concat(source);
                  } else {
                    console.error('No Recovery Methods URL set');
                  }
                } else if (user.profile.status === 'inactive') {
                  if (user.profile.marketplace_login_url) {
                    returnToType = LocationType.MARKETPLACE_LOGIN;
                    returnToUri = user.profile.marketplace_login_url;
                  } else {
                    console.error('No Marketplace Login URL set');
                  }
                }
              } // set the location


              setLocation(returnToType, returnToUri);
              return _context6.abrupt("break", 72);

            case 22:
              _context6.next = 24;
              return userManager.signinSilentCallback();

            case 24:
              _context6.next = 26;
              return getUser();

            case 26:
              user = _context6.sent;
              return _context6.abrupt("break", 72);

            case 28:
              if (!options.popup) {
                _context6.next = 33;
                break;
              }

              _context6.next = 31;
              return userManager.signoutPopupCallback();

            case 31:
              _context6.next = 35;
              break;

            case 33:
              _context6.next = 35;
              return userManager.signoutCallback();

            case 35:
              _context6.next = 37;
              return userManager.removeUser();

            case 37:
              _context6.next = 39;
              return userManager.clearStaleState();

            case 39:
              /*
              // remove any id token in storage
              if ( localStorage && localStorage.removeItem ) {
                  localStorage.removeItem( idTokenKey );
              }
              */
              // fire the sign out event
              events.signOut.fire(); // restore the location

              if (localStorage && localStorage.getItem) {
                returnToUri = localStorage.getItem(returnToKey);

                if (!returnToUri) {
                  returnToUri = getRootUri(true);
                }
              } // set the location


              setLocation(LocationType.SIGN_OUT, returnToUri);
              return _context6.abrupt("break", 72);

            case 43:
              // we are at a normal page
              // save the location
              if (isAuthUri(returnToUri)) {
                if (localStorage && localStorage.getItem) {
                  returnToUri = localStorage.getItem(returnToKey);
                }

                if (!returnToUri) {
                  returnToUri = getRootUri(true);
                }
              }

              if (localStorage && localStorage.setItem) {
                localStorage.setItem(returnToKey, returnToUri);
              } // get the user


              _context6.next = 47;
              return getUser();

            case 47:
              user = _context6.sent;

              if (!(user && !user.expired && (!session || session.session_state === user.session_state))) {
                _context6.next = 51;
                break;
              }

              /*
              if ( localStorage && localStorage.setItem ) {
                  localStorage.setItem( idTokenKey, user.id_token );
              }
              */
              // if a user is signed in, fire the sign in event
              // so the component can update its state
              events.signIn.fire(state);
              return _context6.abrupt("return");

            case 51:
              _context6.next = 53;
              return userManager.removeUser();

            case 53:
              _context6.next = 55;
              return userManager.clearStaleState();

            case 55:
              if (isResuming) {
                _context6.next = 60;
                break;
              }

              // allow canceling the sign in
              cancelSignIn = false;
              events.signInNeeded.fire({
                preventDefault: function preventDefault() {
                  return cancelSignIn = true;
                }
              });

              if (!cancelSignIn) {
                _context6.next = 60;
                break;
              }

              return _context6.abrupt("return");

            case 60:
              if (!options.popup) {
                _context6.next = 69;
                break;
              }

              _context6.next = 63;
              return userManager.signinPopup();

            case 63:
              _context6.next = 65;
              return getUser();

            case 65:
              user = _context6.sent;

              // if there is no user or is expired, try to sign in
              if (user && !user.expired && (!session || session.session_state === user.session_state)) {
                /*
                if ( localStorage && localStorage.setItem ) {
                    localStorage.setItem( idTokenKey, user.id_token );
                }
                */
                // if a user is signed in, fire the sign in event
                // so the component can update its state
                events.signIn.fire(state);
              }

              _context6.next = 71;
              break;

            case 69:
              _context6.next = 71;
              return userManager.signinRedirect();

            case 71:
              return _context6.abrupt("break", 72);

            case 72:
              return _context6.abrupt("return", trace.end());

            case 73:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function signInOrResumeHelper(_x6, _x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }();

  var signOut = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var trace, p, _p2, result;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              trace = traceStart('signOut'); // make sure sign out is only called once at a time
              // the auth process keeps some state and this can get mismatched if called multiple times

              if (!cache.signOutPromise) {
                _context7.next = 6;
                break;
              }

              p = cache.signOutPromise;
              _context7.next = 5;
              return Promise.resolve(p);

            case 5:
              return _context7.abrupt("return", _context7.sent);

            case 6:
              _context7.prev = 6;
              _p2 = signOutHelper();
              cache.signInOrResumePromise = _p2;
              _context7.next = 11;
              return Promise.resolve(_p2);

            case 11:
              result = _context7.sent;
              return _context7.abrupt("return", trace.end(result));

            case 15:
              _context7.prev = 15;
              _context7.t0 = _context7["catch"](6);
              console.error(_context7.t0);
              events.signOutError.fire({
                error: _context7.t0
              });

            case 19:
              _context7.prev = 19;
              cache.signOutPromise = undefined;
              return _context7.finish(19);

            case 22:
              return _context7.abrupt("return", trace.end());

            case 23:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[6, 15, 19, 22]]);
    }));

    return function signOut() {
      return _ref7.apply(this, arguments);
    };
  }();

  var signOutHelper = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var trace, returnToUri;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              trace = traceStart('signOutHelper');
              returnToUri = getCurrentUri(true); // save the location

              if (isAuthUri(returnToUri)) {
                if (localStorage && localStorage.getItem) {
                  returnToUri = localStorage.getItem(returnToKey);
                }

                if (!returnToUri) {
                  returnToUri = getRootUri(true);
                }
              }

              if (localStorage && localStorage.setItem) {
                localStorage.setItem(returnToKey, returnToUri);
              }

              if (!options.popup) {
                _context8.next = 9;
                break;
              }

              _context8.next = 7;
              return userManager.signoutPopup();

            case 7:
              _context8.next = 11;
              break;

            case 9:
              _context8.next = 11;
              return userManager.signoutRedirect();

            case 11:
              return _context8.abrupt("return", trace.end());

            case 12:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function signOutHelper() {
      return _ref8.apply(this, arguments);
    };
  }();

  var hasSession = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var trace, metadata, sessionEndpoint, query, storageToken, res, result, session;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              trace = traceStart('hasSession');
              _context9.prev = 1;
              _context9.next = 4;
              return userManager.metadataService.getMetadata();

            case 4:
              metadata = _context9.sent;
              sessionEndpoint = metadata.token_endpoint.replace('/token', '/session');
              query = '';
              _context9.next = 9;
              return userManager._userStore.get(userManager._userStoreKey);

            case 9:
              storageToken = _context9.sent;

              if (storageToken && typeof storageToken === 'string') {
                query = "?id_token_hint=".concat(encodeURIComponent(JSON.parse(storageToken).id_token));
              }
              /*
              if ( localStorage && localStorage.getItem ) {
                  const idToken = await localStorage.getItem( idTokenKey );
                  if ( idToken ) {
                      query = `?id_token_hint=${ encodeURIComponent( idToken ) }`;
                  }
              }
              */


              _context9.next = 13;
              return fetch("".concat(sessionEndpoint).concat(query), {
                credentials: 'include'
              });

            case 13:
              res = _context9.sent;
              _context9.next = 16;
              return res.json();

            case 16:
              result = _context9.sent;
              return _context9.abrupt("return", trace.end(result.success));

            case 20:
              _context9.prev = 20;
              _context9.t0 = _context9["catch"](1);
              _context9.next = 24;
              return getSession();

            case 24:
              session = _context9.sent;
              return _context9.abrupt("return", trace.end(!!session));

            case 26:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[1, 20]]);
    }));

    return function hasSession() {
      return _ref9.apply(this, arguments);
    };
  }();

  var getSession = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var trace, result;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              trace = traceStart('getSession');
              _context10.prev = 1;
              _context10.next = 4;
              return userManager.querySessionStatus();

            case 4:
              result = _context10.sent;
              return _context10.abrupt("return", trace.end(result));

            case 8:
              _context10.prev = 8;
              _context10.t0 = _context10["catch"](1);
              console.debug(_context10.t0); // using to debug to keep it out of non-verbose logging

              return _context10.abrupt("return", trace.end(null));

            case 12:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[1, 8]]);
    }));

    return function getSession() {
      return _ref10.apply(this, arguments);
    };
  }();

  function getSSOToken() {
    var trace = traceStart('getSSOToken');

    if (location.hash && location.hash.indexOf('sso_token=') > 0) {
      return trace.end(location.hash.substring(location.hash.indexOf('sso_token=')).split('=')[1]);
    }

    return trace.end(null);
  }

  var delegate = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(company, subject) {
      var trace, metadata, user, subjectHeader, subjectPayload, subjectToken, response, data, payload, userInfoResponse, userInfo, _user;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              trace = traceStart('delegate');
              _context11.next = 3;
              return userManager.metadataService.getMetadata();

            case 3:
              metadata = _context11.sent;
              _context11.next = 6;
              return userManager.getUser();

            case 6:
              user = _context11.sent;

              if (!(metadata && state.original.access_token)) {
                _context11.next = 35;
                break;
              }

              subjectHeader = base64Encode(JSON.stringify({
                alg: 'none'
              }));
              subjectPayload = base64Encode(JSON.stringify({
                aud: options.clientId,
                cmp: company,
                sub: subject || state.original.subject,
                may_act: {
                  aud: options.clientId,
                  cmp: state.original.claims.company_id,
                  sub: state.original.subject
                }
              }));
              subjectToken = "".concat(subjectHeader, ".").concat(subjectPayload, ".");
              _context11.next = 13;
              return fetch(metadata.token_endpoint, {
                method: 'POST',
                headers: {
                  'content-type': 'application/x-www-form-urlencoded'
                },
                body: ["grant_type=".concat(encodeURIComponent('urn:ietf:params:oauth:grant-type:token-exchange')), "&subject_token=".concat(subjectToken), "&subject_token_type=".concat(encodeURIComponent('urn:ietf:params:oauth:token-type:jwt')), "&actor_token=".concat(state.original.access_token), "&actor_token_type=".concat(encodeURIComponent('urn:ietf:params:oauth:token-type:access_token')), "&client_id=".concat(encodeURIComponent(options.clientId))].join('')
              });

            case 13:
              response = _context11.sent;
              _context11.next = 16;
              return response.json();

            case 16:
              data = _context11.sent;

              if (!response.ok) {
                _context11.next = 29;
                break;
              }

              payload = jwtDecode(data.access_token); // get the user info for the delegate

              _context11.next = 21;
              return fetch(metadata.userinfo_endpoint, {
                headers: {
                  authorization: "Bearer ".concat(data.access_token)
                }
              });

            case 21:
              userInfoResponse = _context11.sent;
              _context11.next = 24;
              return userInfoResponse.json();

            case 24:
              userInfo = _context11.sent;
              refreshState(user, {
                access_token: data.access_token,
                company_id: payload.cmp,
                subject: payload.sub,
                person_id: payload.person_id,
                permissions: userInfo.permissions || {},
                act: userInfo.act
              });
              return _context11.abrupt("return", trace.end(state));

            case 29:
              _context11.next = 31;
              return userManager.getUser();

            case 31:
              _user = _context11.sent;
              refreshState(_user);
              trace.end();
              throw new Error(data.message || data.error_description);

            case 35:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function delegate(_x9, _x10) {
      return _ref11.apply(this, arguments);
    };
  }();

  var assumeIdentity = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(actorType, subjectCompanyId, subjectAccount) {
      var location,
          postRestoreLocation,
          target,
          validator,
          trace,
          metadata,
          query,
          form,
          clientIdInput,
          actorTypeInput,
          actorTokenInput,
          subjectCompanyInput,
          subjectAccountInput,
          locationInput,
          postRestoreLocationInput,
          _args12 = arguments;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              location = _args12.length > 3 && _args12[3] !== undefined ? _args12[3] : window.location.href;
              postRestoreLocation = _args12.length > 4 && _args12[4] !== undefined ? _args12[4] : window.location.href;
              target = _args12.length > 5 && _args12[5] !== undefined ? _args12[5] : '_self';
              validator = _args12.length > 6 && _args12[6] !== undefined ? _args12[6] : '';
              trace = traceStart('assumeIdentity');
              _context12.next = 7;
              return userManager.metadataService.getMetadata();

            case 7:
              metadata = _context12.sent;
              query = validator ? "?validator=".concat(validator) : '';

              if (metadata && state.original.access_token) {
                form = document.createElement('form');
                form.setAttribute('method', 'POST');
                form.setAttribute('action', metadata.token_endpoint.replace('/token', "/assume-identity".concat(query)));
                form.setAttribute('target', target);
                clientIdInput = document.createElement('input');
                clientIdInput.setAttribute('type', 'hidden');
                clientIdInput.setAttribute('name', 'client_id');
                clientIdInput.setAttribute('value', options.clientId);
                form.appendChild(clientIdInput);
                actorTypeInput = document.createElement('input');
                actorTypeInput.setAttribute('type', 'hidden');
                actorTypeInput.setAttribute('name', 'actor_type');
                actorTypeInput.setAttribute('value', actorType);
                form.appendChild(actorTypeInput);
                actorTokenInput = document.createElement('input');
                actorTokenInput.setAttribute('type', 'hidden');
                actorTokenInput.setAttribute('name', 'actor_token');
                actorTokenInput.setAttribute('value', state.original.access_token);
                form.appendChild(actorTokenInput);
                subjectCompanyInput = document.createElement('input');
                subjectCompanyInput.setAttribute('type', 'hidden');
                subjectCompanyInput.setAttribute('name', 'subject_company_id');
                subjectCompanyInput.setAttribute('value', subjectCompanyId);
                form.appendChild(subjectCompanyInput);

                if (subjectAccount) {
                  subjectAccountInput = document.createElement('input');
                  subjectAccountInput.setAttribute('type', 'hidden');
                  subjectAccountInput.setAttribute('name', 'subject_account');
                  subjectAccountInput.setAttribute('value', subjectAccount);
                  form.appendChild(subjectAccountInput);
                }

                locationInput = document.createElement('input');
                locationInput.setAttribute('type', 'hidden');
                locationInput.setAttribute('name', 'location');
                locationInput.setAttribute('value', location);
                form.appendChild(locationInput);
                postRestoreLocationInput = document.createElement('input');
                postRestoreLocationInput.setAttribute('type', 'hidden');
                postRestoreLocationInput.setAttribute('name', 'post_restore_location');
                postRestoreLocationInput.setAttribute('value', postRestoreLocation);
                form.appendChild(postRestoreLocationInput);
                document.body.appendChild(form);
                form.submit();
              }

              return _context12.abrupt("return", trace.end());

            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function assumeIdentity(_x11, _x12, _x13) {
      return _ref12.apply(this, arguments);
    };
  }();

  var restoreIdentity = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      var target,
          trace,
          metadata,
          form,
          clientIdInput,
          subjectTokenInput,
          _args13 = arguments;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              target = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : '_self';
              trace = traceStart('restoreIdentity');
              _context13.next = 4;
              return userManager.metadataService.getMetadata();

            case 4:
              metadata = _context13.sent;

              if (metadata && state.original.access_token) {
                form = document.createElement('form');
                form.setAttribute('method', 'POST');
                form.setAttribute('action', metadata.token_endpoint.replace('/token', '/restore-identity'));
                form.setAttribute('target', target);
                clientIdInput = document.createElement('input');
                clientIdInput.setAttribute('type', 'hidden');
                clientIdInput.setAttribute('name', 'client_id');
                clientIdInput.setAttribute('value', options.clientId);
                form.appendChild(clientIdInput);
                subjectTokenInput = document.createElement('input');
                subjectTokenInput.setAttribute('type', 'hidden');
                subjectTokenInput.setAttribute('name', 'subject_token');
                subjectTokenInput.setAttribute('value', state.original.access_token);
                form.appendChild(subjectTokenInput);
                document.body.appendChild(form);
                form.submit();
              }

              return _context13.abrupt("return", trace.end());

            case 7:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function restoreIdentity() {
      return _ref13.apply(this, arguments);
    };
  }();

  var refresh = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(authState) {
      var trace, refreshToken, metadata, response, data, hasDelegateToken, delegateCompany, delegateSubject;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              trace = traceStart('refresh');

              if (!authState) {
                authState = state;
              }

              refreshToken = authState.refresh_token;

              if (refreshToken) {
                _context14.next = 5;
                break;
              }

              return _context14.abrupt("return");

            case 5:
              _context14.next = 7;
              return userManager.metadataService.getMetadata();

            case 7:
              metadata = _context14.sent;
              _context14.next = 10;
              return fetch(metadata.token_endpoint, {
                method: 'POST',
                headers: {
                  'content-type': 'application/x-www-form-urlencoded'
                },
                body: ['grant_type=refresh_token', "&refresh_token=".concat(refreshToken), "&client_id=".concat(encodeURIComponent(options.clientId)), options.clientSecret ? "&client_secret=".concat(encodeURIComponent(options.clientSecret)) : ''].join('')
              });

            case 10:
              response = _context14.sent;
              _context14.next = 13;
              return response.json();

            case 13:
              data = _context14.sent;

              if (!response.ok) {
                _context14.next = 25;
                break;
              }

              hasDelegateToken = !!authState.delegate.access_token;
              delegateCompany = authState.delegate.claims.company_id;
              delegateSubject = authState.delegate.subject;
              refreshState({
                id_token: authState.id_token,
                access_token: data.access_token,
                expires_at: Math.floor(new Date().valueOf() / 1000) + data.expires_in,
                refresh_token: data.refresh_token,
                profile: {
                  sub: authState.original.subject,
                  company_id: authState.original.claims.company_id,
                  person_id: authState.original.claims.person_id,
                  preferred_username: authState.original.claims.username,
                  name: authState.original.claims.name,
                  family_name: authState.original.claims.family_name,
                  given_name: authState.original.claims.given_name,
                  locale: authState.original.claims.locale,
                  country: authState.original.claims.country,
                  email: authState.original.claims.email,
                  emails: authState.original.claims.emails,
                  phone_number: authState.original.claims.phone_number,
                  phone_numbers: authState.original.claims.phone_numbers,
                  address: authState.original.claims.address,
                  addresses: authState.original.claims.addresses,
                  picture: authState.original.claims.picture,
                  permissions: authState.original.claims.permissions,
                  attributes: authState.original.claims.attributes,
                  sid: authState.session_id,
                  act: authState.original.act
                }
              });

              if (!hasDelegateToken) {
                _context14.next = 22;
                break;
              }

              _context14.next = 22;
              return delegate(delegateCompany, delegateSubject);

            case 22:
              return _context14.abrupt("return", trace.end(data));

            case 25:
              trace.end();
              throw data;

            case 27:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    return function refresh(_x14) {
      return _ref14.apply(this, arguments);
    };
  }();

  var renew = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      var trace, hasDelegateToken, delegateCompany, delegateSubject, user;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              trace = traceStart('renew');
              hasDelegateToken = !!state.delegate.access_token;
              delegateCompany = state.delegate.claims.company_id;
              delegateSubject = state.delegate.subject;
              _context15.next = 6;
              return userManager.signinSilent();

            case 6:
              if (!hasDelegateToken) {
                _context15.next = 10;
                break;
              }

              delegate(delegateCompany, delegateSubject);
              _context15.next = 14;
              break;

            case 10:
              _context15.next = 12;
              return userManager.getUser();

            case 12:
              user = _context15.sent;
              refreshState(user);

            case 14:
              return _context15.abrupt("return", trace.end());

            case 15:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    return function renew() {
      return _ref15.apply(this, arguments);
    };
  }();

  var setLocation = function setLocation(type, location) {
    var trace = traceStart('setLocation');
    var cancel = false;
    var args = {
      type: type,
      location: location,
      preventDefault: function preventDefault() {
        return cancel = true;
      }
    };
    events.setLocation.fire(args);
    trace.end();

    if (!cancel) {
      window.location = args.location;
    }
  };

  refreshState();

  var sessionExpired = function sessionExpired() {
    var trace = traceStart('sessionExpired');
    var cancelSignOut = false;
    events.sessionExpired.fire({
      preventDefault: function preventDefault() {
        return cancelSignOut = true;
      }
    });

    if (cancelSignOut) {
      return trace.end();
    }

    trace.end();
    signIn();
  };

  var getMetadata = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
      var trace, result;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              trace = traceStart('getMetadata');
              _context16.next = 3;
              return userManager.metadataService.getMetadata();

            case 3:
              result = _context16.sent;
              return _context16.abrupt("return", trace.end(result));

            case 5:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    return function getMetadata() {
      return _ref16.apply(this, arguments);
    };
  }(); //subscribe to expiring


  if (options.monitorAccessTokenExpiration) {
    userManager.events.addAccessTokenExpiring(renew);
    userManager.events.addAccessTokenExpired(sessionExpired);
  } //check for expired session when the tab comes into focus


  var handleVisibilityChange = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
      var trace, expiration, session;
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              trace = traceStart('handleVisibilityChange');

              if (document.hidden) {
                _context17.next = 12;
                break;
              }

              expiration = getExpiration(state.access_token);

              if (!(expiration && expiration.valueOf() < new Date().valueOf())) {
                _context17.next = 11;
                break;
              }

              _context17.next = 6;
              return getSession();

            case 6:
              session = _context17.sent;

              if (!session) {
                _context17.next = 11;
                break;
              }

              _context17.next = 10;
              return renew();

            case 10:
              expiration = getExpiration(state.access_token);

            case 11:
              if (expiration && expiration.valueOf() < new Date().valueOf()) {
                sessionExpired();
              }

            case 12:
              return _context17.abrupt("return", trace.end());

            case 13:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function handleVisibilityChange() {
      return _ref17.apply(this, arguments);
    };
  }();

  if (options.monitorAccessTokenExpiration) {
    document.addEventListener('visibilitychange', handleVisibilityChange, false);
  }

  var module = {
    getUser: getUser,
    removeUser: removeUser,
    refreshState: refreshState,
    getRootUri: getRootUri,
    getCurrentUri: getCurrentUri,
    isAuthUri: isAuthUri,
    signIn: signIn,
    signOut: signOut,
    resume: resume,
    getSession: getSession,
    hasSession: hasSession,
    getSSOToken: getSSOToken,
    delegate: delegate,
    assumeIdentity: assumeIdentity,
    restoreIdentity: restoreIdentity,
    renew: renew,
    refresh: refresh,
    setLocation: setLocation,
    getMetadata: getMetadata
  };
  return _objectSpread({
    get events() {
      return events;
    },

    get options() {
      return options;
    },

    get state() {
      return state;
    }

  }, module);
}
export var getClientIdWithIdentifier = function getClientIdWithIdentifier(clientId, identifier) {
  if (!identifier) {
    return clientId;
  }

  return "".concat(clientId, "; identifier=").concat(identifier);
};
export var identifyClient = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(authority, clientId, clientSecret) {
    var response;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            if (clientId) {
              _context18.next = 2;
              break;
            }

            return _context18.abrupt("return", {
              success: false
            });

          case 2:
            _context18.next = 4;
            return fetch("".concat(authority, "/clients/identify"), {
              method: 'POST',
              headers: {
                'content-type': 'application/x-www-form-urlencoded'
              },
              body: ["&client_id=".concat(encodeURIComponent(clientId)), clientSecret ? "&client_secret=".concat(encodeURIComponent(clientSecret)) : ''].join('')
            });

          case 4:
            response = _context18.sent;
            _context18.next = 7;
            return response.json();

          case 7:
            return _context18.abrupt("return", _context18.sent);

          case 8:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function identifyClient(_x15, _x16, _x17) {
    return _ref18.apply(this, arguments);
  };
}();
export var generateCodeVerifier = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt("return", "".concat(random()).concat(random()).concat(random()));

          case 1:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function generateCodeVerifier() {
    return _ref19.apply(this, arguments);
  };
}();
export var generateCodeChallange = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(codeVerifier) {
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            return _context20.abrupt("return", Base64.stringify(sha256(codeVerifier)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, ''));

          case 1:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));

  return function generateCodeChallange(_x18) {
    return _ref20.apply(this, arguments);
  };
}();
export var LocationType = {
  SIGN_IN: 'sign_in',
  SIGN_OUT: 'sign_out',
  RECOVERY_METHODS: 'recovery_methods'
};

function getUserManagerConfig(options) {
  var config = {};
  var mapping = {
    'authority': 'authority',
    'clientId': 'client_id',
    'clientSecret': 'client_secret',
    'redirectUri': 'redirect_uri',
    'responseType': 'response_type',
    'responseMode': 'response_mode',
    'scope': 'scope',
    'prompt': 'prompt',
    'display': 'display',
    'maxAge': 'max_age',
    'uiLocales': 'ui_locales',
    'loginHint': 'login_hint',
    'acrValues': 'acr_values',
    'clockSkew': 'clockSkew',
    'loadUserInfo': 'loadUserInfo',
    'filterProtocolClaims': 'filterProtocolClaims',
    'postLogoutRedirectUri': 'post_logout_redirect_uri',
    'popupRedirectUri': 'popup_redirect_uri',
    'popupWindowFeatures': 'popupWindowFeatures',
    'popupWindowTarget': 'popupWindowTarget',
    'silentRedirectUri': 'silent_redirect_uri',
    'automaticSilentRenew': 'automaticSilentRenew',
    'silentRequestTimeout': 'silentRequestTimeout',
    'accessTokenExpiringNotificationTime': 'accessTokenExpiringNotificationTime',
    'userStore': 'userStore',
    'monitorSession': 'monitorSession',
    'checkSessionInterval': 'checkSessionInterval',
    'revokeAccessTokenOnSignOut': 'revokeAccessTokenOnSignout',
    'includeIdTokenInSilentRenew': 'includeIdTokenInSilentRenew',
    'staleStateAge': 'staleStateAge',
    'extraQueryParams': 'extraQueryParams',
    'clientAuthentication': 'client_authentication'
  };
  Object.keys(mapping).forEach(function (key) {
    if (options[key] !== undefined) {
      config[mapping[key]] = options[key];
    }
  });
  return config;
}

function getExpiration(jwt) {
  if (!jwt) {
    return null;
  }

  return new Date(jwtDecode(jwt).exp * 1000);
}

function base64Encode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}
//# sourceMappingURL=auth.js.map